import React from "react";
import "./styles.css";
import FormattedMessage from "components/FormattedMessage/index";
import PlanDetails from "../PlanDetails/index";
import { get } from "lodash";
import { PREPAID_PLAN_SUB_TYPES } from "utils/constants";
import { formatCurrency, formatGBtoTBConversion } from "utils/helpers";
import { PlusOutline } from "components/Icons";
import { currencyFormatSelector } from "ducks/selectors";
import { useSelector } from "react-redux";

const MonthlyPlanCard = ({
  planTitle = "Your Monthly Plan",
  payMonthlyItems,
  referralCode,
  planDetails,
  payTodayItems,
  data = {},
  addons,
  defaultPlanAddons,
  themeColors,
  excludeTax,
  simCounts
}) => {
  const { totalPrice, totalData, totalEntepriseData,totalAmountWithoutTax,totalTaxAmount,totalEnterpriseAmount } = payMonthlyItems;
  console.log("MONTHLY PLA",payMonthlyItems,simCounts)
  const reduxCurrencyFormat = useSelector(currencyFormatSelector);
  const currencyFormat = reduxCurrencyFormat;

  const totalEnterpirseValueAllSimsWithoutDiscount = formatCurrency(totalAmountWithoutTax * simCounts?.totalSimCount,currencyFormat);
  const totalEnterpriseDiscountValueAllSims = totalTaxAmount * simCounts?.totalSimCount;
  
  // const planName = get(planDetails, "name", "");
  const planSubType = get(planDetails, "sub_type", "");
  // const productLink = get(planDetails, "product_link");
  const isPrepaid = PREPAID_PLAN_SUB_TYPES.includes(planSubType);
  const paySummaryItems = isPrepaid ? payTodayItems : payMonthlyItems;
  const items = get(paySummaryItems, "items");
  const planItem = items ? items.find(i => i.type === "plan") : {};
  // const planPrice = excludeTax
  //   ? get(planItem, "price_without_tax")
  //   : get(planItem, "price");

  const planCountries = payMonthlyItems?.planCountries;
  // const isBorderlessPlan = payMonthlyItems?.isBorderlessPlan;
  const planOriginalPrice = payMonthlyItems?.originalPrice;
  // const selectedBorderlessAddons = payMonthlyItems?.selectedBorderlessAddons;
  const CONVERSION_GAP = 1000

  let convertedTotalData =  totalEntepriseData >= CONVERSION_GAP ? formatGBtoTBConversion(totalEntepriseData) : totalEntepriseData;

  const values = {
    totalPrice,
    totalData,
    totalEntepriseData:convertedTotalData,
    totalEnterpriseAmount
  }
  return (
    <div className="plan-card">
      {/* Card Body */}
      <div className="plan-card-body">
        {/* Header Row */}
        <div className="plan-card-header">
          <h3 className="plan-title">{planTitle}</h3>
          <span className="plan-base-price">{totalEnterpirseValueAllSimsWithoutDiscount}</span>
        </div>

        {/* Feature List */}
        {/* <ul className="plan-feature-list">
          {features.map((feature, idx) => (
            <li key={idx} className="feature-item">
              <DoubleCheckIcon />
              <span>{feature}</span>
            </li>
          ))}
        </ul> */}

        <PlanDetails
          planDetails={planDetails}
          items={items}
          planTotalData={totalData}
          planCountries={planCountries}
          planOriginalPrice={planOriginalPrice}
          {...data}
        />

        {defaultPlanAddons && defaultPlanAddons.filter(a => a.selected).length > 0 && (
          <div style={{ marginTop: "24px" }}>
            <h3 className="plan-title" style={{ marginBottom: "16px" }}>
              <FormattedMessage id={get(data, "defaultAddonsTitle", "default_addons_title")} />
            </h3>
            <ul className="plan-feature-list" style={{ marginBottom: "0px" }}>
              {defaultPlanAddons.filter(a => a.selected).map((item, index) => {
                // const addonsPrice = excludeTax ? item.price_without_tax : item.price;
                return (
                  <li key={index} className="feature-item" style={{ justifyContent: "space-between" }}>
                    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                      <PlusOutline color="#0000ff" />
                      <span>{item.label}</span>
                    </div>
                    {/* <span style={{ color: "#0000ff", fontWeight: "bold", fontSize: "20px" }}>
                       {addonsPrice}
                    </span> */}
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {addons && addons.filter(a => a.selected).length > 0 && (
          <div style={{ marginTop: "24px" }}>
            <h3 className="plan-title" style={{ marginBottom: "16px" }}>
              <FormattedMessage id="addons" />
            </h3>
            <ul className="plan-feature-list" style={{ marginBottom: "0px" }}>
              {addons.filter(a => a.selected).map((item, index) => {
                // const addonsPrice = excludeTax ? item.price_without_tax : item.price;
                return (
                  <li key={index} className="feature-item" style={{ justifyContent: "space-between" }}>
                    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                      <PlusOutline color="#0000ff" />
                      <span>{item.label}</span>
                    </div>
                    {/* <span style={{ color: "#0000ff", fontWeight: "bold", fontSize: "20px" }}>
                       {addonsPrice}
                    </span> */}
                  </li>
                );
              })}
            </ul>
          </div>
        )}

          <div className="plan-benefits-section" style={{ marginTop: "32px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <h3 className="plan-title" style={{ marginBottom: "0px" }}>Your Benefits</h3>
              {(() => {
                const benefitItems = items ? items.filter(i => i.type === "benefit") : [];
                if (benefitItems.length > 0) {
                  // const totalValue = benefitItems.reduce((acc, curr) => acc + (curr.value || 0), 0);
                  if (totalEnterpriseDiscountValueAllSims !== 0) {
                    const symbol = (planItem.price || '$').replace(/[\d.,\-+ ]/g, '').trim() || '$';
                    const sign = totalEnterpriseDiscountValueAllSims < 0 ? "-" : "+";
                    return (
                      <span className="benefit-discount" style={{ fontSize: "20px" }}>
                        {sign} {symbol}{Math.abs(totalEnterpriseDiscountValueAllSims).toFixed(2)}
                      </span>
                    );
                  }
                }
                return null;
              })()}
            </div>
            
            <ul className="benefits-list">
              {items && items.filter(i => i.type === "benefit").map((item, index) => (
                <li key={`item-${index}`} className="benefit-item">
                  <span className="benefit-text" style={{ color: "#0099ff" }}>{item.label}</span>
                </li>
              ))}
            </ul>
          </div>
      </div>

      {/* Bottom Highlight Banner */}
      <div className="plan-highlight-banner">
        <span className="banner-text">
          <FormattedMessage html id="ent_monthly_total_data_for_price_tb" values={values}/>
        </span>
        <div className="banner-circle-accent" />
      </div>
    </div>
  );
};

export default MonthlyPlanCard;